import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import {
  handleChange,
  handleChangeCheck,
  handleChangeFile,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonInput from "../../../components/forms/CommonInput";
import { adicionarDias, formataData } from "../../../helpers/mesesHelper";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonSwal from "../../../components/Swal/commonSwal";
import CommonCheckboxSimNao from "../../../components/forms/CommonCheckboxSimNao";
import PropTypes from "prop-types";

function FeriasModal({ isOpen, setIsOpen, valuesHook, salvarFerias }) {
  const { feriasValues, setFeriasValues } = valuesHook;
  const [periodoAquisitivo, setPeriodoAquisitivo] = React.useState([]);

  React.useEffect(() => {
    const regexData = /^\d{4}-\d{2}-\d{2}$/;

    if (!regexData.test(feriasValues?.periodo_ferias_inicio)) return;

    let fimFerias = adicionarDias(
      feriasValues?.dias_ferias,
      feriasValues?.periodo_ferias_inicio
    );
    setFeriasValues((prevValues) => ({
      ...prevValues,
      periodo_ferias_fim: fimFerias,
    }));
  }, [feriasValues, setFeriasValues]);

  //Define período aquisitivo
  React.useEffect(() => {
    let dataInicio = feriasValues?.periodo_disponivel_inicio;
    let dataFim = feriasValues?.periodo_disponivel_fim;

    if (dataInicio !== "Indisponível") {
      let optionText = `${formataData(dataInicio)} até ${formataData(dataFim)}`;
      setPeriodoAquisitivo({ 1: optionText });
    } else {
      let optionText = "Indisponível";
      setPeriodoAquisitivo({ 1: optionText });
    }
    setFeriasValues((prevValues) => ({
      ...prevValues,
      periodoAquisitivo: 1,
    }));
  }, [
    feriasValues?.periodo_disponivel_fim,
    feriasValues?.periodo_disponivel_inicio,
    setFeriasValues,
    isOpen,
  ]);

  const exibePeriodos = () => {
    CommonSwal({
      icon: "question",
      html: feriasValues?.hint,
    });
  };

  return (
    <CommonModal
      title={"Férias do colaborador"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="xl"
      buttons={
        <CommonButton
          key={`cadastar-ferias`}
          onClick={salvarFerias}
          color="success"
        >
          Cadastrar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonSelect
            label={
              <>
                Período aquisitivo
                <button
                  onClick={exibePeriodos}
                  style={{ background: "none", border: "none" }}
                >
                  <i
                    className="far fa-question-circle text-primary"
                    id="hintPeriodo"
                  ></i>
                </button>
              </>
            }
            id="periodoAquisitivo"
            value={feriasValues.periodoAquisitivo}
            onChange={(e) => {
              handleChange(e, feriasValues, setFeriasValues);
            }}
            data={Object.keys(periodoAquisitivo).map((id) => ({
              text: periodoAquisitivo[id],
              id: id,
            }))}
            placeholder="Selecione uma quantidade"
            required
            disabled
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputDate
            label="Inicio das férias"
            id="periodo_ferias_inicio"
            value={feriasValues.periodo_ferias_inicio}
            onChange={(e) => handleChange(e, feriasValues, setFeriasValues)}
            required
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputDate
            label="Fim das férias"
            id="periodo_ferias_fim"
            value={feriasValues.periodo_ferias_fim}
            onChange={(e) => handleChange(e, feriasValues, setFeriasValues)}
            required
            disabled
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Dias de férias"
            id="dias_ferias"
            value={feriasValues.dias_ferias}
            onChange={(e) =>
              handleChangeNumeral(e, feriasValues, setFeriasValues, 1, 30)
            }
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mb-3">
          <CommonInputDate
            label="Data de pagamento"
            id="data_pagamento"
            value={feriasValues.data_pagamento}
            onChange={(e) => handleChange(e, feriasValues, setFeriasValues)}
            required
          />
        </div>
        <div className="col-lg-3 mb-3">
          <CommonInputValor
            label="Valor"
            id="valor"
            value={feriasValues.valor}
            onChange={(e) => {
              handleChangeNameValue(
                "valor",
                e.target.value,
                feriasValues,
                setFeriasValues
              );
            }}
            required
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="novoArquivo"
            accept="application/pdf"
            onChange={(e) => handleChangeFile(e, feriasValues, setFeriasValues)}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <CommonCheckboxSimNao
            label="Colaborador deseja vender 1/3 das férias?"
            id="vender_terco_ferias"
            value={feriasValues.vender_terco_ferias}
            onChange={(e) =>
              handleChangeCheck(e, feriasValues, setFeriasValues)
            }
          />
        </div>
      </div>
    </CommonModal>
  );
}

FeriasModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    feriasValues: PropTypes.object.isRequired,
    setFeriasValues: PropTypes.func.isRequired,
  }).isRequired,
  salvarFerias: PropTypes.func.isRequired,
};

export default FeriasModal;
